import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

// Letzte Verteidigungslinie gegen die weisse Seite (B2). Jeder Fehler, der
// bis hierher durchschlaegt, bekommt einen lesbaren Text und einen Rueckweg.
// Die Navigation laeuft bewusst ueber window.location statt ueber den Router:
// wenn der Fehler aus dem Router selbst kommt (z. B. Search-Param-Validierung),
// ist dessen Kontext nicht mehr vertrauenswuerdig. Ein harter Reload setzt
// zusaetzlich den kaputten Zustand zurueck.
export function FehlerSeite({ error }: { error: unknown }) {
  const text =
    error instanceof Error && error.message !== '' ? error.message : 'Unbekannter Fehler';

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-cream p-6 text-center">
      <AlertTriangle className="h-10 w-10 text-coral" aria-hidden />
      <h1 className="font-serif text-xl text-ink">Da ist etwas schiefgelaufen</h1>
      <p className="max-w-lg break-words text-sm text-ink-soft">{text}</p>
      <button
        type="button"
        onClick={() => {
          window.location.href = '/';
        }}
        className="inline-flex min-h-[44px] items-center rounded-md bg-akzent px-4 py-2 text-sm text-cream hover:bg-akzent-stark"
      >
        Zurück zum Dashboard
      </button>
    </div>
  );
}

type Props = { children: ReactNode };
type State = { error: unknown };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: unknown): State {
    return { error };
  }

  componentDidCatch(error: unknown, info: ErrorInfo): void {
    console.error('Unbehandelter Fehler:', error, info);
  }

  render(): ReactNode {
    if (this.state.error !== null) {
      return <FehlerSeite error={this.state.error} />;
    }
    return this.props.children;
  }
}
